import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'dibs-react-intl';
import classNames from 'classnames';
import styles from '../../styles/main.scss';

// components
import Text from '../inputs/Text';

const messages = defineMessages({
    placeholder: {
        id: 'dc.CreditCardForm.Expiry.placeholder',
        defaultMessage: 'Exp (MM/YY)*',
    },
});

const onChangeHandler = (event, onChange) => {
    const { value = '', selectionStart } = event.target;
    //remove all non digit characters
    let newValue = value.replace(/[^0-9]/g, '');
    //add slash in the middle
    if (newValue.length >= 3) {
        newValue = `${newValue.slice(0, 2)}/${newValue.slice(2)}`;
    }
    const inputNode = event.target;
    //if slash was added, move typing cursor 1 character further
    const offset = newValue[selectionStart - 1] === '/' ? 1 : 0;
    onChange({ name: 'cardExpiry', value: newValue }, () => {
        inputNode.setSelectionRange(selectionStart + offset, selectionStart + offset);
    });
};

const ExpiryComponent = ({
    value,
    autoFocus = false,
    isBlurred,
    disabled,
    error,
    onChange,
    onBlur = () => {},
    fullWidth = false,
}) => {
    const intl = useIntl();
    return (
        <Text
            name="cardExpiry"
            value={value}
            wrapperClass={classNames(styles.left, {
                [styles.fullWidth]: fullWidth,
            })}
            placeholder={intl.formatMessage(messages.placeholder)}
            pattern="\d*"
            maxLength="5"
            autoComplete="cc-exp"
            dataTn="billing-cardExpiry"
            autoFocus={autoFocus}
            isBlurred={isBlurred}
            disabled={disabled}
            error={error}
            onChangeEvent={event => {
                onChangeHandler(event, onChange);
            }}
            onBlur={onBlur}
            inputMode="numeric"
        />
    );
};

ExpiryComponent.propTypes = {
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    autoFocus: PropTypes.bool,
    isBlurred: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    fullWidth: PropTypes.bool,
};

export const Expiry = ExpiryComponent;
